module.exports = __webpack_public_path__ + "static/media/5.79bded75.jpg";